import { PdIcon } from "./pd-icon/PdIcon.js";
//#region src/pd-icon/pd-icon.ts
var tag = "pd-icon";
if (!customElements.get(tag)) customElements.define(tag, PdIcon);
//#endregion
export { PdIcon };
